'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('SalesViewer', ['Role', function (Role) {
    class SalesViewer extends Role {
        
    }

    return SalesViewer.newFrozenInstance(
        'ListClusters',
        'ListOrders',
        'ListOrderComments',
        'ListOrderTasks',
        'ShowOrderTask',
        'ListOrderLineItems',
        'ListLineItemComments',
        'ListLineItemTasks',
        'ShowLineItemTask'
    )
}]);